import styled, { keyframes } from "styled-components";

import { Button, SingleLine } from "components/atoms";
import { AvailableLanguages } from "utils/types";
import copies from "utils/copies";

const floating = keyframes`
  0% {
    transform: translate(0, 0px);
  }
  50% {
    transform: translate(0, 10px);
  }
  100% {
    transform: translate(0, 0px);
  }
`;

const AnimatedButton = styled(Button)`
  border: none;
  cursor: pointer;
  background-color: transparent;
  &:hover {
    animation: ${floating} 1.5s infinite;
  }
  & > p {
    font-family: "Finger Paint", cursive;
    font-size: 1em;
    color: green;
    margin-top: 0;
  }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 16px;
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
`;

const MessageWrapper = styled.div`
  width: min(640px, 92vw);
  background: rgba(250, 250, 250, 0.98);
  text-align: center;
  border-radius: 16px;
  padding: 22px 18px 16px;
  box-shadow: 0 18px 70px rgba(0, 0, 0, 0.35);

  & > div > p {
    font-size: 2em;
    font-family: "Kranky", cursive;
    color: green;
    margin: 0.2em 0;
  }
`;

const LanguageOptionsContainer = styled.div`
  display: flex;
  justify-content: center;
`;

interface InitialPromptProps {
  handleLanguagePress: (lang: AvailableLanguages) => void;
  hidden: boolean;
}

export const InitialPrompt = ({
  handleLanguagePress,
  hidden,
}: InitialPromptProps) => {
  const { pickALanguagePrompt, spCopy, enCopy } = copies;

  const onLanguagePress = (lang: AvailableLanguages) => {
    handleLanguagePress(lang);
  };

  return (
    <Overlay
      aria-hidden={hidden}
      style={
        hidden
          ? { opacity: 0, transition: "200ms", pointerEvents: "none" }
          : { opacity: 1 }
      }
    >
      <MessageWrapper role="dialog" aria-modal="true">
        <div>
          <SingleLine line={pickALanguagePrompt.spanish} />
          <SingleLine line={pickALanguagePrompt.english} />
        </div>
        <LanguageOptionsContainer>
          <label>
            <AnimatedButton
              onClick={() => onLanguagePress(AvailableLanguages.ES)}
              hasText
              text={spCopy}
              hasImage
              image={require("assets/images/spain-flag.png")}
            />
          </label>
          <label>
            <AnimatedButton
              onClick={() => onLanguagePress(AvailableLanguages.EN)}
              hasText
              text={enCopy}
              hasImage
              image={require("assets/images/usa_flag.png")}
            />
          </label>
        </LanguageOptionsContainer>
      </MessageWrapper>
    </Overlay>
  );
};
